import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { TranslocoService } from "@jsverse/transloco";
import { LorenEntityFormModel } from "../../../../shared/modules/loren-entity-form-card/interfaces/loren-entity-form-model.interface.ts";
import { LorenFieldTypes } from "../../../../shared/modules/loren-entity-form-card/enums/loren-field-types.enum";

@Component({
    selector: "loren-loren-trace-feature-selector-dialog",
    templateUrl: "./loren-trace-feature-selector-dialog.component.html",
    styleUrls: ["./loren-trace-feature-selector-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenTraceFeatureSelectorDialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<LorenTraceFeatureSelectorDialogComponent>>(MatDialogRef);
  private translocoService = inject(TranslocoService);

  formModel: LorenEntityFormModel;

  ngOnInit(): void {
    this.prepareAssetFeatureSelectorForm();
  }

  continue() {
    this.dialogRef?.close({ selectedFeatures: this.prepareResult() });
  }

  handleFormFieldInteraction($event) {
    const field = this.formModel.formFields.find(
      (field) => field.name === $event.fieldName
    );
    if (field) {
      field.value = $event.fieldCurrentValue;
    }
  }

  private prepareAssetFeatureSelectorForm() {
    const formModel: LorenEntityFormModel = {
      formFields: [
        {
          name: "traces",
          label: this.translocoService.translate("operations.show_traces"),
          value: true,
          formControlType: LorenFieldTypes.CHECKBOX,
        },
        {
          name: "panic",
          label: this.translocoService.translate("operations.show_alarms"),
          value: true,
          formControlType: LorenFieldTypes.CHECKBOX,
        },
      ],
      formName: "",
    };

    this.formModel = formModel;
  }

  private prepareResult() {
    const result = {};
    this.formModel.formFields.forEach((x) => (result[x.name] = x.value));
    return result;
  }
}
